if (!customElements.get('ohmm-jewelry-offers')) {
  customElements.define('ohmm-jewelry-offers', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.root = window.Shopify?.routes?.root || '/';
      this.buttons = [...this.querySelectorAll('[data-item-ids]')];
      this.status = this.querySelector('[role="status"]');
      this.buttons.forEach(button => button.addEventListener('click', () => this.addSet(button)));
      this.refresh = () => { if (!this.busy) this.sync().catch(() => {}); };
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh);
      }
      window.addEventListener('pageshow', this.refresh);
      this.sync().catch(() => this.buttons.forEach(button => { button.disabled = false; }));
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      window.removeEventListener('pageshow', this.refresh);
      this.ready = false;
    }
    async cart() {
      const response = await fetch(this.root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error(this.dataset.error);
      return response.json();
    }
    has(cart, id) {
      return cart.items.some(item => String(item.variant_id) === String(id) && !item.selling_plan_allocation && item.quantity > 0);
    }
    ids(button) { return button.dataset.itemIds.split(','); }
    labels(cart) {
      this.buttons.forEach(button => {
        const complete = this.ids(button).every(id => this.has(cart, id));
        button.textContent = complete ? this.dataset.view : button.dataset.label;
        button.disabled = false;
      });
    }
    async sync() { this.labels(await this.cart()); }
    async addSet(button) {
      if (this.busy || window.ohmmOfferBusy) return;
      this.busy = true;
      window.ohmmOfferBusy = true;
      this.status.textContent = '';
      this.buttons.forEach(item => { item.disabled = true; });
      button.textContent = this.dataset.adding;
      try {
        const before = await this.cart();
        const items = this.ids(button)
          .filter(id => !this.has(before, id)).map(id => ({ id: Number(id), quantity: 1 }));
        if (!items.length) { window.location.assign(this.root + 'cart'); return; }
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer?.getSectionsToRender?.().map(section => section.id);
        const response = await fetch(this.root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, ...(sections ? { sections, sections_url: window.location.pathname } : {}) })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        const after = await this.cart();
        this.labels(after);
        this.status.textContent = this.dataset.added;
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ohmm-jewelry-offers' });
        if (drawer && result.sections && sections.every(id => result.sections[id])) {
          drawer.setActiveElement?.(button);
          drawer.classList.remove('is-empty');
          drawer.renderContents(result);
        } else { window.location.assign(this.root + 'cart'); }
      } catch (error) {
        this.status.textContent = error.message || this.dataset.error;
        await this.sync().catch(() => { button.textContent = button.dataset.label; });
      } finally {
        this.busy = false;
        window.ohmmOfferBusy = false;
        this.buttons.forEach(item => { item.disabled = false; });
      }
    }
  });
}
